import ms from 'ms'
import { FIAT_ORDER } from '@exodus/models'

const isTxWithinInterval = ({ date, interval }) => Math.abs(date - Date.now()) < interval

const createFiatRampAnalyticsPlugin = ({ fiatOrdersAtom, analytics }) => {
  let unsubscribe

  const onStart = () => {
    analytics.requireDefaultEventProperties(['assetPurchasedLast90', 'assetSoldLast90'])

    unsubscribe = fiatOrdersAtom.observe((orders) => {
      let assetPurchasedLast90 = false
      let assetSoldLast90 = false

      for (const order of orders) {
        if (
          order.orderType === FIAT_ORDER.ORDER_TYPES.buy &&
          order.exodusStatus === FIAT_ORDER.ORDER_STATUS.complete &&
          isTxWithinInterval({ date: new Date(order.date), interval: ms('90d') })
        ) {
          assetPurchasedLast90 = true
          break
        }
      }

      for (const order of orders) {
        if (
          order.orderType === FIAT_ORDER.ORDER_TYPES.sell &&
          order.exodusStatus === FIAT_ORDER.ORDER_STATUS.complete &&
          isTxWithinInterval({ date: new Date(order.date), interval: ms('90d') })
        ) {
          assetSoldLast90 = true
          break
        }
      }

      analytics.setDefaultEventProperties({ assetPurchasedLast90, assetSoldLast90 })
    })
  }

  const onStop = () => {
    unsubscribe?.()
  }

  return { onStart, onStop }
}

const fiatRampAnalyticsPluginDefinition = {
  id: 'fiatRampAnalyticsPlugin',
  type: 'plugin',
  factory: createFiatRampAnalyticsPlugin,
  dependencies: ['analytics', 'fiatOrdersAtom'],
  public: true,
}

export default fiatRampAnalyticsPluginDefinition
